import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { BlockGuard } from '../../types/api/Block';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import {
  UserMembershipsContentList,
  MembershipsByPageType,
  UserMembershipDefault,
  UserMembershipEdit,
} from '../../_lib/components/UserMemberships';

type ProcessMembershipsDefault = MembershipsByPageType<{ process: UserMembershipDefault[] }>;
type ProcessMembershipsEdit = MembershipsByPageType<{ process: UserMembershipEdit[] }>;

export type ProcessMembershipsProps = Views<
  DefaultView<ProcessMembershipsDefault> & OptionalEditView<ProcessMembershipsEdit>
>;

function ProcessMemberships({ views }: ProcessMembershipsProps) {
  const { editModeInfo } = useAppContext();
  const editModeActive = editModeInfo.active;
  const { memberships } = editModeActive && views.edit ? views.edit.embedded : views.default.embedded;

  const process = memberships?.process;

  return process ? <UserMembershipsContentList memberships={process} /> : null;
}

export const ProcessMembershipsBlock = asFetchableBlock(ProcessMemberships, BlockType.processMemberships);
export type ProcessMembershipsBlock = ComponentProps<typeof ProcessMembershipsBlock>;
export const isProcessMembershipsBlock = BlockGuard<ProcessMembershipsBlock>(BlockType.processMemberships);
